import React from 'react'
import IconGlobe from 'front-end/src/components/common/icon/IconGlobe'
import { ValueType, Props as SelectProps } from 'react-select'

import { SupportedLocalesEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'

import Select from '../select/Select'
import { isIE } from 'shared/helpers'

type LocaleOption = {
  value: string
  label: string
}

type LanguageDropdownProps = Omit<SelectProps<LocaleOption, false>, 'value'> & {
  className?: string
  value?: SupportedLocalesEnum | null
  defaultValue?: SupportedLocalesEnum
  onChange?: (data: SupportedLocalesEnum) => void
}

const languages: LocaleOption[] = [
  { value: SupportedLocalesEnum.ptBr, label: 'Português (BR)' },
  { value: SupportedLocalesEnum.enUs, label: 'English (US)' },
  { value: SupportedLocalesEnum.esEs, label: 'Español' },
  { value: SupportedLocalesEnum.enGb, label: 'English (UK)' },
  { value: SupportedLocalesEnum.ptPt, label: 'Português (PT)' },
  { value: SupportedLocalesEnum.deDe, label: 'Deutsch' },
  { value: SupportedLocalesEnum.itIt, label: 'Italiano' },
  { value: SupportedLocalesEnum.frFr, label: 'Français' },
  { value: SupportedLocalesEnum.zhHans, label: '簡體中文' }, // Chinese (simplified)
  { value: SupportedLocalesEnum.zhHant, label: '中國傳統的' }, // Chinese (traditional)
  { value: SupportedLocalesEnum.viVn, label: 'Tiếng Việt' } // Vietnamese
  //{ value: SupportedLocalesEnum.jaJa, label: 'Japanese' }, // For later
  //{ value: SupportedLocalesEnum.ruRu, label: 'Russian' } // For later
]

// hide it for production or IE11. On IE it causes weird crashes. Probably bad font handling on IE11 side.
if (process.env.LOOOP_ENVIRONMENT !== 'prod' && isIE === false) {
  languages.push({
    value: SupportedLocalesEnum.pseudo,
    label: 'Pseudolocalization'
  })
}

const findOption = (value?: SupportedLocalesEnum): LocaleOption =>
  languages.find((language) => language.value === value) as LocaleOption

export const LanguageDropdown: React.FC<LanguageDropdownProps> = ({
  value,
  defaultValue,
  onChange,
  ...other
}) => {
  const handleChange = (data: ValueType<LocaleOption, false>) => {
    if (!data) {
      return
    }

    const { value } = data

    if (onChange) {
      onChange(value as SupportedLocalesEnum)
    }
  }

  const props: SelectProps = {
    menuPlacement: 'auto',
    isSearchable: false,
    options: languages.sort((a, b) => {
      return a.label.localeCompare(b.label)
    }),
    onChange: handleChange,
    ...(value && { value: findOption(value) }),
    ...(defaultValue && { defaultValue: findOption(defaultValue) }),
    ...other
  }
  // @ts-expect-error
  return <Select leftAddon={<IconGlobe />} {...props} />
}
